import { DeliveryDatesEffects } from './offers.delivery.dates.effect';
import { OffersEffects } from './offers.effect';

export const OfferEffects = [OffersEffects, DeliveryDatesEffects];

export * from './offers.effect';
